import { processMenu } from "@/_core/data/api_calls/menu/processMenu";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Fetches the menu configuration for commodities.
 *
 * @param {object} ctx - Context containing user and commodity information.
 * @returns {Promise} - Returns a promise resolving to the processed menu data.
 */
export function getMenuCommodities(ctx) {
  const variables = {
    format: "json",
    commodity: ctx.commodityNumber,
    user: ctx.user.pk_idusers
  };
  return processMenu(ctx, {
    fetch: gatewayService.catalogs.menuCommodities,
    variables
  });
}
